import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guard/auth.guard.service';
import { RoleGuard } from './guard/role.guard.service';
import { SigninComponent } from './signin/signin/signin.component';
import { PwchangeComponent } from './signin/pwchange/pwchange.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { MailchangeComponent } from './signin/mailchange/mailchange.component';
import { HomeComponent } from './home/home.component';
import { CardSigninComponent } from './signin/card-signin/card-signin.component';
import { FscSigninComponent } from './signin/fsc-signin/fsc-signin.component';
import { FavoriteSigninComponent } from './signin/favorite-signin/favorite-signin.component';
import { RegisterFavComponent } from './signin/register-fav/register-fav.component';

const routes: Routes = [
  { path: 'signin', component: SigninComponent, canActivate: [] },
  { path: 'card-signin', component: CardSigninComponent, canActivate: [] },
  { path: 'fsc-signin', component: FscSigninComponent, canActivate: [] },
  { path: 'favorite-signin', component: FavoriteSigninComponent, canActivate: [] },
  { path: 'register-fav', component: RegisterFavComponent, canActivate: [AuthGuard] },
  { path: 'pwchange', component: PwchangeComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'mailchange', component: MailchangeComponent, canActivate: [AuthGuard, RoleGuard] },

  { path: '', component: HomeComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'general-affairs/reservation', component: NotFoundComponent, pathMatch: 'full' },
  { path: 'general-affairs/reservation', loadChildren: () => import('app/general-affairs/reservation/ga-reservation.module').then(m => m.GaReservationModule) },
  { path: 'general-affairs/master', component: NotFoundComponent, pathMatch: 'full' },
  { path: 'general-affairs/master', loadChildren: () => import('app/general-affairs/master/ga-master.module').then(m => m.GaMasterModule) },
  { path: 'general-affairs/general-affairs', component: NotFoundComponent, pathMatch: 'full' },
  { path: 'general-affairs/general-affairs', loadChildren: () => import('app/general-affairs/general-affairs/ga-general-affairs.module').then(m => m.GaGeneralAffairsModule) },
  { path: 'kitchen', component: NotFoundComponent, pathMatch: 'full' },
  { path: 'kitchen', loadChildren: () => import('app/kitchen/kitchen.module').then(m => m.KitchenModule) },
  { path: 'individual', component: NotFoundComponent, pathMatch: 'full' },
  { path: 'individual', loadChildren: () => import('app/individual/individual.module').then(m => m.IndividualModule) },
  { path: 'fsc', component: NotFoundComponent, pathMatch: 'full' },
  { path: 'fsc', loadChildren: () => import('app/fsc/fsc.module').then(m => m.FscModule) },
  { path: 'scan-card', component: NotFoundComponent, pathMatch: 'full' },
  { path: 'scan-card', loadChildren: () => import('app/scan-card/scan-card.module').then(m => m.ScanCardModule) },
  { path: 'cafemenu-term', component: NotFoundComponent, pathMatch: 'full' },
  { path: 'cafemenu-term', loadChildren: () => import('app/cafemenu-term/cafemenu-term.module').then(m => m.CafemenuTermModule) },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    AuthGuard,
    RoleGuard,
  ]
})
export class AppRoutingModule { }
